import RecoveredOrdersPage from './RecoveredOrdersPage'

export default RecoveredOrdersPage
